import React from 'react'
import cn from 'classnames'
import cookie from 'cookie'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import lang from 'lang'
import { AUTHENTICATE_USER } from 'services/actions'
import Modal from 'common/components/modal'
import { wrapper } from 'common/store'
import ExternalHtml from 'common/services/html-content/external-html'
import {
  changeRegisterFormField,
  registerRequest,
  validateField,
} from 'page-modules/register/service/actions'
import AuthFooter from 'components/auth/footer'
import AuthFeature from 'components/auth/feature-container'
import Head from 'components/head'
import Form from 'common/components/form'

@connect(
  (state) => {
    return {
      fullName: state.register.formData.fullName,
      email: state.register.formData.email,
      password: state.register.formData.password,
      registrationCode: state.register.formData.registrationCode,
      loading: state.register.loading,
      errors: state.register.errors,
    }
  },
  (dispatch) => ({
    changeFormField: (key, value) => dispatch(changeRegisterFormField(key, value)),
    registerRequest: (requestData) => dispatch(registerRequest(requestData)),
    validateField: (field, value, validations) =>
      dispatch(validateField(typeof field === 'string' ? { field, value, validations } : field)),
  }),
)
export default class Register extends Form {
  static getInitialProps = wrapper.getInitialPageProps((store) => async ({ req, res }) => {
    if (req && req.headers.cookie) {
      const cookies = cookie.parse(req.headers.cookie)
      const jwt = cookies['ruler-jwt']
      store.dispatch({ type: AUTHENTICATE_USER, payload: { jwt, res } })
    }
  })

  static propTypes = {
    fullName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    registrationCode: PropTypes.string,
    loading: PropTypes.bool,
    registerRequest: PropTypes.func,
    errors: PropTypes.object,
  }

  static validations = {
    fullName: 'nonEmpty alphanumericWithAccents',
    email: 'nonEmpty email',
    password: 'nonEmpty lengthMin8',
    registrationCode: 'nonEmpty',
  }

  constructor(props) {
    super(props)
    this.state = {
      shownPassword: false,
    }
  }

  toggleShownPasswordHandler() {
    return () => {
      this.setState((prevState) => ({
        shownPassword: !prevState.shownPassword,
      }))
    }
  }

  registerHandler() {
    return (e) => {
      e.preventDefault()
      this.props.registerRequest({
        fullName: { value: this.props.fullName.trim(), validations: Register.validations.fullName },
        email: { value: this.props.email.trim(), validations: Register.validations.email },
        password: { value: this.props.password, validations: Register.validations.password },
        registrationCode: {
          value: this.props.registrationCode,
          validations: Register.validations.registrationCode,
        },
      })
    }
  }

  render() {
    return (
      <div>
        <Head title="Registration" />
        <Modal />
        <div className="main-auth-container">
          <div className="grid-x grid-padding-x align-center">
            <div className="small-11 medium-10 large-4 cell">
              <div className="auth-content">
                <header className="auth-header">
                  <div className="logo">
                    <img
                      src="https://ruleronlineimgs.s3.amazonaws.com/logos/ruler-logo.svg"
                      alt="Ruler logo"
                    />
                  </div>
                  <h1 className="app-auth-title">
                    <ExternalHtml slug="register/title-text" />
                  </h1>
                </header>
                <main className="auth-main">
                  <span className={cn('form-error', { 'is-visible': this.props.errors.base })}>
                    {this.props.errors.base}
                  </span>
                  <form
                    id="app-reg-form"
                    className="reg-form"
                    action=""
                    data-abide
                    noValidate
                    onSubmit={this.registerHandler()}>
                    <label htmlFor="reg-code">{lang.registrationCode}</label>
                    <input
                      type="text"
                      id="reg-code"
                      required
                      pattern="alpha_numeric"
                      value={this.props.registrationCode}
                      className={cn({ 'is-invalid-input': this.props.errors.registrationCode })}
                      onChange={this.createFieldHandler('registrationCode')}
                      onBlur={this.createFieldValidationHandler(
                        'registrationCode',
                        Register.validations.registrationCode,
                      )}
                    />
                    <span
                      className={cn('form-error', {
                        'is-visible': this.props.errors.registrationCode,
                      })}>
                      {this.props.errors.registrationCode}
                    </span>
                    <label htmlFor="first-name">{lang.fullName}</label>
                    <input
                      type="text"
                      id="first-name"
                      required
                      pattern="alpha_numeric"
                      value={this.props.fullName}
                      className={cn({ 'is-invalid-input': this.props.errors.fullName })}
                      onChange={this.createFieldHandler('fullName')}
                      onBlur={this.createFieldValidationHandler(
                        'fullName',
                        Register.validations.fullName,
                      )}
                    />
                    <span
                      className={cn('form-error', {
                        'is-visible': this.props.errors.fullName,
                      })}>
                      {this.props.errors.fullName}
                    </span>
                    <label htmlFor="e-mail">{lang.auth.emailLabel}</label>
                    <input
                      type="text"
                      id="e-mail"
                      required
                      pattern="email"
                      value={this.props.email}
                      className={cn({ 'is-invalid-input': this.props.errors.email })}
                      onChange={this.createFieldHandler('email')}
                      onBlur={this.createFieldValidationHandler(
                        'email',
                        Register.validations.email,
                      )}
                    />
                    <span className={cn('form-error', { 'is-visible': this.props.errors.email })}>
                      {this.props.errors.email}
                    </span>
                    <div className="password-wrapper">
                      <label htmlFor="password">{lang.auth.password}</label>
                      <input
                        type={this.state.shownPassword ? 'text' : 'password'}
                        id="password"
                        autoComplete="off"
                        required
                        pattern="alpha_numeric"
                        value={this.props.password}
                        className={cn({ 'is-invalid-input': this.props.errors.password })}
                        onChange={this.createFieldHandler('password')}
                        onBlur={this.createFieldValidationHandler(
                          'password',
                          Register.validations.password,
                        )}
                      />
                      <span
                        className={cn('form-error', { 'is-visible': this.props.errors.password })}>
                        {this.props.errors.password}
                      </span>
                      <button
                        id="show-password"
                        type="button"
                        className={cn('show-pass', { active: this.state.shownPassword })}
                        aria-hidden="true"
                        onClick={this.toggleShownPasswordHandler()}
                        tabIndex="-1"
                        title="Show Password">
                        <i className="icon-eye" />
                      </button>
                    </div>
                    <p>
                      {`${lang.auth.register.accept} `}
                      <a href="/terms" rel="noopener noreferrer" target="_blank">
                        {lang.tos}
                      </a>
                      {` ${lang.auth.register.and} `}
                      <a href="/privacy" rel="noopener noreferrer" target="_blank">
                        {lang.privacy}
                      </a>
                    </p>
                    <button type="submit" disabled={this.props.loading} className="button expanded">
                      {lang.auth.register.submitButton}
                    </button>
                    <p>
                      {`${lang.auth.register.callToAction} `}
                      <a href="/login">{lang.auth.logIn}</a>
                    </p>
                    <p>
                      {lang.auth.register.callToActionSubtitle1}
                      <br />
                      {lang.auth.register.callToActionSubtitle2}
                    </p>
                  </form>
                </main>
                <AuthFooter />
              </div>
            </div>
          </div>
        </div>
        <AuthFeature />
      </div>
    )
  }
}
